import React, {useEffect, useState} from 'react'
import {Modal, Button, Breadcrumb, List, message} from 'antd'
import {FolderOutlined, FolderOpenOutlined, HomeOutlined} from '@ant-design/icons'
// import Editor from "../../../utils/brace";
import ApiManagementAPI from '../../../apis/apiManagementAPI'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

const ChooseFile = (props) => {
  const {dataIngestion, ingestionId, dataType, t} = props
  const [initFileData, setInitFileData] = useState([])
  const [fileData, setFileData] = useState([])
  const [isListloading, setIsListloading] = useState(false)
  const [breadList, setBreadList] = useState([])

  useEffect(() => {
    getSFTPChooseList()
  }, [])

  const getSFTPChooseList = (e) => {
    setIsListloading(true)
    let params = {
      ingestionId: ingestionId,
      dataIngestion: dataIngestion,
      path: e ? Base64.encode(e) : null
    }

    if (dataType === 'SFTP') {
      ApiManagementAPI.getSFTPChooseList(params).then(res => {
        if (!e) {
          setInitFileData(res.data.data)
        }
        setFileData(res.data.data ? res.data.data : [])
        setIsListloading(false)
      })
    } else if (dataType === 'Blob') {
      ApiManagementAPI.getBlobChooseList(params).then(res => {
        if (!e) {
          setInitFileData(res.data.data)
        }
        setFileData(res.data.data ? res.data.data : [])
        setIsListloading(false)
      })
    }
  }

  const handleCancel = () => {
    props.closeChooseFile()
  }

  const handleOk = () => {
    if (breadList.length > 0) {
      let path = '/' + breadList.join('/')
      props.setPath(path)
      props.closeChooseFile()
    } else {
      message.warning('Please Choose File!').then()
    }
  }

  const onFileClick = (e) => {
    let arr = [...breadList, e.fileName]
    setBreadList(arr)
    let path = '/' + arr.join('/')
    getSFTPChooseList(path)
  }

  const allClick = () => {
    setFileData(initFileData)
    setBreadList([])
  }

  const breadcrumbClick = (e) => {
    let arr = breadList
    arr.map((item, index) => {
      if (e === item) {
        arr.splice(index + 1)
      }
      return arr
    })
    setBreadList([...arr])
    let path = '/' + [...arr].join('/')
    getSFTPChooseList(path)
  }

  return (
    <>
      <Modal
        visible={true}
        title={t(`general.chooseFile`)}
        width={1000}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t(`general.cancel`)}
          </Button>,
          <Button key="Save" type="primary" onClick={handleOk}>{t(`general.save`)}</Button>,
        ]}
      >
        <Breadcrumb>
          <Breadcrumb.Item onClick={allClick}>
            <a><HomeOutlined/></a>
          </Breadcrumb.Item>
          {
            breadList.map((item) => {
              return (
                <Breadcrumb.Item key={item} onClick={() => breadcrumbClick(item)}>
                  <a>{item}</a>
                </Breadcrumb.Item>
              )
            })
          }
        </Breadcrumb>
        <List
          style={{height: '400px', overflowY: 'scroll'}}
          loading={isListloading}
          dataSource={fileData}
          split={false}
          renderItem={item => (
            <List.Item className="isHover" onClick={() => { onFileClick(item) }}>
              <List.Item.Meta
                avatar={item.dir ? <FolderOpenOutlined/> : <FolderOutlined/>}
                title={item.fileName}
              />
            </List.Item>
          )}
        />
      </Modal>
    </>
  )
}

export default withTranslation()(ChooseFile)
